import styled from 'styled-components';
import { colors, heading3, heading4, spacing, heading5 } from 'ui/theme';
import { PageHeader } from 'ui/pageHeader';

export const IndexTitle = styled.h3`
  ${heading3};
`;

export const IntelligentInsightsSpacedPageHeader = styled(PageHeader)`
  margin-top: ${spacing.threeQuarter};
  margin-bottom: ${spacing.double};
`;

export const IntelligentInsightsBackground = styled.div`
  background-color: ${colors.backgroundSecondary};
  padding: ${spacing.double} 0;
`;

export const ContainerStackedRow = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerSpacedBetween = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ContainerCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MainHeaderTimeRangeContainer = styled(ContainerCenter)`
  gap: ${spacing.half};
`;

export const IndexContainerHeader = styled.h4`
  ${heading4};
  margin-bottom: ${spacing.quarter};
`;

export const IntelligentInsightsHeader = styled.h5`
  ${heading5};
  display: flex;
  align-items: center;
  scroll-margin-top: ${spacing.plusHalf};
`;
